export const BatchHighlightingOptions = [
  {
    name: "Students with pending login",
    _id: "pending_login",
    defaultSelected: true,
  },
  {
    name: "Students with no attempts",
    _id: "no_attempts",
  },
  {
    name: "Students with minimal attempts",
    _id: "minimal_attempts",
  },
  {
    name: "Low scoring students",
    _id: "lowest_scored",
  },
  {
    name: "Students with unfinished attempts",
    _id: "unfinished_attempts",
  },
  {
    name: "Students demonstrating improvement",
    _id: "demonstrating_improvement",
  },
  {
    name: "Dedicated students",
    _id: "deactivated_students",
  },
];

export const InterviewVariantTypes = {
  ASSESSMENT: 'assessment',
  VERBAL_MOCK: 'verbal_mock',
  VERBAL_IW: 'verbal_iw',
  CODING_MOCK: 'coding_mock',
  CODING_IW: 'coding_iw',
  CASE_MOCK: 'case_mock',
  CASE_IW: 'case_iw'
};

// Array version for easier iteration if needed
export const InterviewVariantTypeOptions = [
  { value: 'assessment', label: 'Assessment' },
  { value: 'verbal_mock', label: 'Verbal Mock' },
  { value: 'verbal_iw', label: 'Verbal Interview Wizard' },
  { value: 'coding_mock', label: 'Coding Mock' },
  { value: 'coding_iw', label: 'Coding Interview Wizard' },
  { value: 'case_mock', label: 'Case Mock' },
  { value: 'case_iw', label: 'Case Interview Wizard' }
];

export const isCaseVariant = (type) =>
  type === InterviewVariantTypes.CASE_MOCK || type === InterviewVariantTypes.CASE_IW;

export const isCodingVariant = (type) =>
  type === InterviewVariantTypes.CODING_MOCK || type === InterviewVariantTypes.CODING_IW;

// Case overall scores are stored on a 0-10 scale; category scores stay on 0-100.
export const CASE_SCORE_MAX = 10;
export const CASE_CATEGORY_MAX = 100;

// Mirrors CASE_CATEGORIES in the backend's caseAnalytics.util.ts. Order matters:
// it is the order the bars and the category tiles render in.
export const CASE_CATEGORIES = [
  { id: 'caseIntroduction', label: 'Strategic Context & Scoping', color: '#6E5DC6' },
  { id: 'hypothesisAndFramework', label: 'Logic Tree & MECE Structure', color: '#52B8CC' },
  { id: 'dataAnalysis', label: 'Quantitative Synthesis', color: '#1151A6' },
  { id: 'hypothesisTesting', label: 'Root-Cause Validation', color: '#737DA8' },
  { id: 'conclusionAndRecommendations', label: 'Conclusion', color: '#D46A00' },
  { id: 'speech', label: 'Speech', color: '#9DB2F2' },
];

export const DurationTypes = {
  THIS_WEEK: 'this_week',
  LAST_15_DAYS: 'last_15_days',
  LAST_MONTH: 'last_month',
  LAST_3_MONTHS: 'last_3_months'
};

// Array version compatible with Usage component
export const DurationOptions = [
  { _id: 'this_week', name: 'This Week' },
  { _id: 'last_15_days', name: 'Last 15 Days' },
  { _id: 'last_month', name: 'Last Month' },
  { _id: 'last_3_months', name: 'Last 3 Months' },
  { _id: 'all_time', name: 'All Time' }
];

export const LeaderboardOptions = [
  { _id: 'best_score', name: 'High Score' },
  { _id: 'most_dedicated', name: 'Most dedicated' },
];

// Only the case leaderboards can rank ascending server-side; the verbal, coding
// and assessment endpoints would silently fall back to a high-score sort, so
// the option is offered for case variants alone.
export const LowScoreLeaderboardOption = { _id: 'low_score', name: 'Low Score' };

export const getLeaderboardOptions = (interviewVariantType) => (
  isCaseVariant(interviewVariantType)
    ? [...LeaderboardOptions, LowScoreLeaderboardOption]
    : LeaderboardOptions
);
        